module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/tik-tok-poster-4df629f209a2d43f21d254b12fb0c21b.jpg";